import { client, gql } from 'data-provider';

export const getTransactionToken = async () => {
  const query = gql`
    query {
      generateTransactionToken
    }
  `;

  const data = await client.request(query);
  return data.generateTransactionToken as string;
};
